import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader.component';
import { LottieModule } from 'ngx-lottie';

@NgModule({
  declarations: [LoaderComponent],
  imports: [CommonModule, LottieModule],
  exports: [LoaderComponent],
})
export class LoaderModule {}
